import { Box, Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  Key as KeyIcon,
  Devices as DevicesIcon,
  CheckCircle as CheckCircleIcon,
  Lock as LockIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { LoadingIndicator, PageHeader } from '@/components/common';
import { StatCard, QuickActions } from '../components';
import { useDashboardStats } from '../hooks';
import { TIME_WINDOW_OPTIONS, TIME_WINDOW_LABEL } from '../constants';

/**
 * Dashboard 页面
 *
 * 显示系统统计数据和快速操作入口。
 */
export default function Dashboard() {
  const { t } = useTranslation();
  const { stats, loading, timeWindow, setTimeWindow } = useDashboardStats();

  if (loading && !stats) {
    return <LoadingIndicator fullPage />;
  }

  return (
    <Box>
      <PageHeader
        title={t('dashboard.title')}
        action={
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <InputLabel>{TIME_WINDOW_LABEL}</InputLabel>
            <Select
              value={timeWindow}
              label={TIME_WINDOW_LABEL}
              onChange={(e) => setTimeWindow(e.target.value as number)}
            >
              {TIME_WINDOW_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        }
      />

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title={t('dashboard.totalLicenses')}
            value={stats?.total_licenses ?? 0}
            icon={<KeyIcon />}
            color="primary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title={t('dashboard.activeLicenses')}
            value={stats?.active_licenses ?? 0}
            icon={<CheckCircleIcon />}
            color="success"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title={t('dashboard.activeDevices')}
            value={stats?.active_devices ?? 0}
            icon={<DevicesIcon />}
            color="info"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title={t('dashboard.lockedDevices')}
            value={stats?.locked_devices ?? 0}
            icon={<LockIcon />}
            color="warning"
          />
        </Grid>
      </Grid>

      <QuickActions />
    </Box>
  );
}
